export default __webpack_public_path__ + "static/media/DSC_0546.cdb4062c.jpg";